export const Especie = {
  CACHORRO: "CACHORRO",
  GATO: "GATO",
} as const;

export const Genero = {
  MACHO: "MACHO",
  FEMEA: "FEMEA",
} as const;

export const Porte = {
  PEQUENO: "PEQUENO",
  MEDIO: "MEDIO",
  GRANDE: "GRANDE",
} as const;

export type EspecieType = typeof Especie[keyof typeof Especie];
export type GeneroType = typeof Genero[keyof typeof Genero];
export type PorteType = typeof Porte[keyof typeof Porte];